import { isPlatformBrowser } from '@angular/common';
import { Component, ElementRef, Inject, OnDestroy, OnInit, PLATFORM_ID, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { SlickCarouselComponent } from 'ngx-slick-carousel/slick.component';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs/internal/Subscription';
import { ApiService } from '../../shared/services/apiService.service';
import { SkeletonService } from '../../shared/services/skeleton.service';
import { environment } from '../../../environments/environment';
import { secureStorage } from '../../shared/services/encryption/secureservice';
import { RootService } from 'src/app/shared/services/root.service';
import { BehaviourSubjectService } from 'src/app/shared/services/behaviour-subject.service';
import { FormErrorService } from 'src/app/shared/form-validation/form-error.service';
import { RegexService } from 'src/app/shared/form-validation/regex.service';
declare var $: any;

@Component({
  selector: 'app-tataokpdppage',
  templateUrl: './tataokpdppage.component.html',
  styleUrls: ['./tataokpdppage.component.scss']
})
export class TataokpdppageComponent implements OnInit,OnDestroy {

  productLoaded: boolean = false;
  environment1 = environment.s3bucket.url;
  checkBoxcheked:boolean=false;
  @ViewChild('myCheckbox') myCheckbox: ElementRef;

  @ViewChild('slickModal') slickModal1: SlickCarouselComponent;
  @ViewChild('slickHLModal') slickModal: SlickCarouselComponent;

  @ViewChild('slickModal1') slickModal2: SlickCarouselComponent;
  @ViewChild('slickHLModal1') slickModal3: SlickCarouselComponent;
  sub: Subscription = new Subscription();

  productPrice:any
  id: any;
ProductDetail:any=[];
  userData: any;
  pageURL: string;
  DealermoileNo: any;
  isUserLoggedIn: boolean = false;
  utm_source: any;
  utm_medium: any;
  utm_campaign: any;
  gclid: any;
  campaign_id:any
  userLoginForm: any;
  isshowLogin: boolean=false;
  isshowOtp: boolean=false;
  isshowSignUp: boolean=false;
  checkBoxControl = new FormControl(false);
  disableForm:boolean=false;
  isUserDetail: boolean = false;
  vehicleId: any;
  constructor(private activatedRoute: ActivatedRoute,private formErrorService: FormErrorService,private regexService: RegexService,private fb: FormBuilder, private rootService: RootService,private behaviourSub: BehaviourSubjectService,private route: ActivatedRoute,private apiservice:ApiService,public skeletonService: SkeletonService,private spinner: NgxSpinnerService, private toastrService: ToastrService,@Inject(PLATFORM_ID) private platformId: Object,private router: Router,private localStorage: secureStorage,
) {  }
  thumbSlider = {
    infinite: false,
    speed: 300,
    slidesToShow: 5,
    slidesToScroll: 5,
    asNavFor: '.imagepreview,.popimagepreview,.popimgthumbs',
    dots: false,
    autoplay: false,
    draggable: true,
    focusOnSelect: true,
    prevArrow: '.client-thumbnails .prev-arrow',
    nextArrow: '.client-thumbnails .next-arrow',
    vertical: true,
  };
  imageSlider = {
    infinite: false,
    speed: 300,
    slidesToShow: 1,
    slidesToScroll: 1,
    fade: true,
    dots: true,
    autoplay: false,
    draggable: false,
    prevArrow: '.client-feedback .prev-arrow',
    nextArrow: '.client-feedback .next-arrow',
    asNavFor: '.thumbs,.popimagepreview,.popimgthumbs',
  };
  popthumbSlider = {
    infinite: false,
    speed: 300,
    slidesToShow: 5,
    slidesToScroll: 1,
    asNavFor: '.popimagepreview',
    dots: false,
    autoplay: false,
    draggable: true,
    focusOnSelect: true,
    vertical: false,
    arrows: false,
  };
  popimageSlider = {
    infinite: false,
    speed: 300,
    slidesToShow: 1,
    slidesToScroll: 1,
    fade: true,
    dots: false,
    autoplay: false,
    draggable: false,
    prevArrow: '.client-feedback .prev-arrow',
    nextArrow: '.client-feedback .next-arrow',
    asNavFor: '.popimgthumbs',
  };
  defaultImage: string = '../../../assets/images/default_image.jpg';

  userFormpdp: FormGroup;
  ngOnInit(): void {
    this.pageURL = window.location.href;
    this.route.params.subscribe(params => {
      this.id = params['id'];
      this.getVehicleDetail(this.id)
    });
    this.sub.add(
      this.behaviourSub.isLoggedIn.subscribe(() => {
        this.isUserLoggedIn = this.rootService.isLoggedIn() ? true : false;
        this.userData = this.rootService.getUserData();
          if(this.isUserLoggedIn){
            this.closeModel()
          }
      })
    );
    this.sub.add(this.behaviourSub.isTataOkLogin.subscribe((ele)=>{
      let data = {
        name:this.userData?.first_name + ' ' + this.userData?.last_name,
        contact:this.userData?.mobile_number
      }
     if(ele && this.vehicleId){
      // if(window.location.href(''))
      this.isUserDetail = true;
      this.createLead(data);
     }
    }));
    this.userform()
    this.getUserdata();
    this.campaign();
    this.setLoginHome();
    this.sub.add(
      this.behaviourSub.isLoggedIn.subscribe(() => {
        this.isUserLoggedIn = this.rootService.isLoggedIn() ? true : false;
      })
    );
    localStorage.setItem('catIdid','false')
  }
  campaign() {
    this.activatedRoute.queryParams.subscribe(async (params: any) => {
      this.utm_source = await params['utm_source'];
      this.utm_medium = await params['utm_medium'];
      this.utm_campaign = await params['utm_campaign'] || await params['utm_campaignname'];
      this.gclid = await params['gclid'];
      this.campaign_id = await params['campaign_id'];
    })
  }
  getVehicleDetail(id:any){
 let payload:any={"id":id};
 this.spinner.show();
 try {
  this.sub.add(this.apiservice.getPdppagedetail(payload).subscribe({
    next: (data:any) => {
     this.productLoaded=true
     this.ProductDetail=data.data
      // Check if vehicle_documents is empty, then set default image
    if (!this.ProductDetail.vehicle_documents || this.ProductDetail.vehicle_documents.length === 0) {
      this.ProductDetail.vehicle_documents = [{ path: '../../../assets/images/default_image.jpg' }];
    }
     this.ProductDetail.vehicle_documents.sort((a, b) => (a.is_cover === true ? -1 : 1));


     if (this.ProductDetail?.vehicle_documents.length > 5) {
       this.popthumbSlider.slidesToScroll = 1;
     } else {
       this.popthumbSlider.slidesToScroll = 5;
     }
     this.productPrice=this.ProductDetail.dealer_suggestive_price
     this.getDealer()
      this.spinner.hide();
    },
    error: (error) => {
      this.spinner.hide();
    }
  })
  )
} catch (error) {
}


  }
  getUserdata() {
    this.sub.add(this.apiservice.getUserData().subscribe({
      next: (response: any) => {
        if (response?.success) {
          this.userData = response.data;
          if (localStorage.getItem('formData')) {
            const savedFormData = JSON.parse(localStorage.getItem('formData')!);
            // this.createLead(savedFormData);
          }
          this.setForm();
        } else {
          this.userData = null;
        }
        this.checkBoxcheked = false;
      },
      error: () => {
        this.userData = null;
        // this.setForm();
      }
    }));
  }
  notAllowSpace(event: any) {
    if (event.target.selectionStart === 0 && event.which === 32) {
      event.preventDefault();
    }
  }

  onlyNumberKey(event: any) {
    return this.regexService.NumberKeyEvent(event);
  }
  userform(){
    this.userFormpdp = this.fb.group({
      name: ['', [Validators.required]],
      contact: ['', [Validators.required, Validators.pattern(/^\d{10}$/)]],
      consent: ['', Validators.required]
    });
  }
  onCheckboxChange(checked: boolean) {
    if (checked) {
      this.checkBoxcheked=true
    } else {
      this.checkBoxcheked=false
    }
  }

  getConsentData(value) {
    const signup = JSON.parse(this.localStorage.getItem("signup")) ? true : false;
    let data = {
      "mobile_number": value,
      'source': signup ? 'Web Registration' : 'Web Login'
    }
    this.apiservice.get_amc_consent_view(data).subscribe((res) => {
    })
  }
  
  setForm() {
    if (isPlatformBrowser(this.platformId)) {
      const firstName = typeof this.userData?.first_name === 'string' ? this.userData?.first_name : '';
      const lastName = typeof this.userData?.last_name === 'string' ? this.userData?.last_name : '';
      const fullName = firstName && lastName ? `${firstName} ${lastName}` : '';

      this.userFormpdp = this.fb.group({
        name: [fullName || '', [Validators.required]],  // Allow empty for manual entry
        contact: [this.userData?.mobile_number ? this.userData.mobile_number : '',
                  [Validators.required, Validators.pattern(/^\d{10}$/)]],
        consent: ['yes', Validators.required]
      });

      this.myCheckbox.nativeElement.checked = false;

      if (this.userFormpdp.controls['contact'].invalid) {
        this.userFormpdp.controls['contact'].markAsTouched();
      }
    }
  }
  onSubmit() {
if(this.isUserLoggedIn){
  const userData = this.localStorage.getItem('userData');
  if (this.userFormpdp.valid) {
    if (userData) {
      this.createLead(this.userFormpdp.value);
    }
  }else {
    this.toastrService.warning("Form is invalid");
  }

} else {

  localStorage.setItem('previousUrl', '/buy-used-vehicles-productdetail/' + this.id);
  localStorage.setItem('formData', JSON.stringify(this.userFormpdp.value));
  // this.router.navigate(['/login/']);
  // this.behaviourSub.isTataOkPLPPage.next(true)
  this.userLoginForm.reset();
  if (isPlatformBrowser(this.platformId)){
  this.checkBoxControl.setValue(false);
    let ele =  document.getElementById('otpVerification');
    ele.click();
    this.vehicleId = this.id;
  }
 
}
  }
  imagePreviewpopup() {
    $('#imageFullScreenModeModal').modal('show', function () { });
    $('#imageFullScreenModeModal').on('shown.bs.modal', function () {
      $('.gallery').slick('setPosition');
      $('.gallery2').slick('setPosition');
    });
  }

  imagePreviewpopupClose() {
    $('#imageFullScreenModeModal').modal('hide');
  }
  nextSlide() {
    this.slickModal.slickNext();
    this.slickModal1.slickNext();
    this.slickModal2.slickNext();
    this.slickModal3.slickNext();
  }
  prevSlide(){
    this.slickModal.slickPrev();
    this.slickModal1.slickPrev();
    this.slickModal2.slickPrev();
    this.slickModal3.slickPrev();
  }
  nextSlide1(){
    this.slickModal3.slickNext();
  }
  prevSlide1(){
    this.slickModal2.slickPrev();
    this.slickModal3.slickPrev();
  }
  createLead(data:any){
    if (isPlatformBrowser(this.platformId)) {
    const nameParts = data.name.split(' ');
    const firstName = nameParts[0];
    const lastName = nameParts[1];
   let Payload={
    "first_name":firstName?firstName:'',
    "last_name": lastName?lastName:'',
    "mobile_no":data.contact,
    "vehicle_id":this.id,
    "lead_source":"osp",
    "financing":data.consent == 'yes' ? true : false,
    "address_one":this.userData?.address_one,
          "address_two":this.userData?.address_two,
          "city":this.userData?.city,
          "district":this.userData?.district,
          "pincode":this.userData?.pincode,
          "state":this.userData?.state,
          "taluka":this.userData?.taluka,
          "utm_source":this.utm_source ? this.utm_source : '',
          "utm_medium":this.utm_medium  ? this.utm_medium : '',
         "utm_campaign":this.utm_campaign ? this.utm_campaign : '',
         "campaign_id":this.campaign_id ? this.campaign_id : '',
         "device_source":"Fleet Verse Web"

   };
   this.spinner.show()
   try {
    this.sub.add(this.apiservice.getCreateLead(Payload).subscribe({
      next: (response) => {
        if (response.success) {
          this.spinner.hide();
          this.productLoaded=true
          this.toastrService.success(response.data.msg || response.msg)
          if(this.isUserDetail){
            this.getUserdata();
          }
          this.myCheckbox.nativeElement.checked = false;
          // const previousUrl = localStorage.getItem('previousUrl') || '/';
          // this.router.navigate([previousUrl]);
          localStorage.removeItem('formData');
          localStorage.removeItem('previousUrl');
        }
        else{
          if(this.isUserDetail){
            this.getUserdata();
          }
          this.spinner.hide();
          this.toastrService.warning(response.data.msg || response.msg)
        }

      },
      error: (error) => {
        if(this.isUserDetail){
          this.getUserdata();
        }
        this.spinner.hide();
      },
     })
    )
  } catch (error) {
  }
    }
  }

  onMouseMove(event: MouseEvent, imageElement: HTMLImageElement) {
    const rect = imageElement.getBoundingClientRect();
    const { width, height } = rect;

    const offsetX = event.clientX - rect.left;
    const offsetY = event.clientY - rect.top;

    const xPercent = (offsetX / width) * 100;
    const yPercent = (offsetY / height) * 100;
    const scale = 1.8;
    imageElement.style.transformOrigin = `${xPercent}% ${yPercent}%`;
    imageElement.style.transform = `scale(${scale})`;
  }

  onMouseLeave(imageElement: HTMLImageElement) {
    imageElement.style.transform = 'scale(1)';
  }
  getFirstPartOfOwners(owners: string | undefined): string {
    if (!owners) {
      return '';
    }
    return owners.split(/[-\s]/)[0];
  }
  openSocialSharePopup() {
    $('#socialShareModal').modal('show', function () {});
  }
  copyMessage() {
    this.toastrService.success('Link copied.');
    navigator.clipboard.writeText(this.pageURL);
  }
  closeSocialSharePopup() {
    $('#socialShareModal').modal('hide');
  }

  getDealer() {
    if (isPlatformBrowser(this.platformId)) {
    localStorage.removeItem("dealername")
    {
      let data = {
        "dealer_code": this.ProductDetail?.distributor_code,
        "action_type": "dropdown"
    };
      this.sub.add(this.apiservice.getDealerList(data).subscribe({
        next: (response: any) => {
          if (response["success"]) {
            this.DealermoileNo = response?.data?.[0]?.mobile_number;
          }
        },
        error: (error) => {
          this.toastrService.warning(error.data.msg);
        },
        complete: () => {
        }
      })
      );

    }
  }
  }

  
  closeModel() {
    if (isPlatformBrowser(this.platformId)) {
      let element = document.getElementById('closeBtn1');
     
      if(element && this.isshowLogin){
        element.click();
      }
      let element1 = document.getElementById('closeBtn2');
      if(element1){
        element1.click();
      }
    }
  }

  setLoginHome(){
    if (isPlatformBrowser(this.platformId)) {
    this.userLoginForm = this.fb.group({
      mobile_number: [this.userData?.mobile_number ? this.userData?.mobile_number : '', [Validators.required, Validators.pattern(this.regexService.Phone)]],
    });
    }
  }

  showLogin() {
    this.isshowLogin = true;
    this.isshowOtp = false;
    this.isshowSignUp = false;
    if(window.location.href.includes('buy-used-vehicles-productdetail')){
      let ele = document.getElementById('otpVerification')
      ele.click(); 
    }
  }

  showOtp() {
    this.isshowLogin = false;
    this.isshowOtp = true;
    this.isshowSignUp = false;
  }

  showSignup(){
    this.isshowLogin = false
    this.isshowOtp = false;
    this.isshowSignUp = true;
  }

  sentOtp() {
    if (isPlatformBrowser(this.platformId)) {
      if (this.userLoginForm.status === 'INVALID') {
        this.formErrorService.displayFormErrors(this.userLoginForm);
        return;
      }
      this.spinner.show();
      let data = {
        mobile_number: this.userLoginForm.controls['mobile_number'].value,
        action_type: 'login',
        user_source: "Tataok"
      };
      this.sub.add(
        this.apiservice.sentOtp1(data).subscribe({
          next: (response: any) => {
            if (response.success) {
              this.toastrService.success(response.data.msg);
              this.spinner.hide();
              if(this.checkBoxcheked && this.userLoginForm.controls['mobile_number']?.value){
                this.getConsentData(this.userLoginForm.controls['mobile_number']?.value)
              }
              this.localStorage.setItem("loginNumber", JSON.stringify(this.userLoginForm.controls['mobile_number'].value))
              localStorage.removeItem("signup")
              this.isshowLogin = false
              this.isshowOtp = true;
              this.isshowSignUp = false;

              if (isPlatformBrowser(this.platformId)) {
                window.scroll(0, 0);
              }
            }
            else {
                  this.toastrService.warning('Something went wrong!');
                  this.spinner.hide();
                  this.closeModel()
                }
          },
          error: () => {
            this.toastrService.warning('Something went wrong!');
            this.spinner.hide();
            this.closeModel()
          },
          complete: () => { },
        })
      );
    }
  }
  
  ngOnDestroy(): void {
    if (isPlatformBrowser(this.platformId)) {
      this.sub.unsubscribe()

    }
  }
}
